<div class="continent-box">
  <ng-container *ngIf="data && memberStoreValue.loadingRef == false ; else loading">
  <a [routerLink]="goToFederation()"><img [lazyLoad]="data.Logo.URL" /></a>
  <div class="text-info">
    <p>
      {{ data.CaName }} {{'member.intro1'| transloco}}
      {{ data.Continent }}.<span *ngIf="data.Founded"> {{'member.founded' | transloco}}{{ data.Founded }}.</span>
    </p>
    <p>
      {{'member.worldarcheryhas' | transloco}} {{ membersCount }} {{'member.federation' | transloco}} {{ data.Continent }}.
    </p>
    <a  class="uppertext-no-viewport more-info" [routerLink]="goToFederation()">
      {{'more_info' | transloco}}
     </a>
  </div>
</ng-container>
<ng-template #loading>
  <app-load-more-button
    [areMoreData]="false"
    [loading]="true"
  ></app-load-more-button>
</ng-template>
</div>
